import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { newsApi, NewsListParams } from '@/api/news';
import { Artikel } from '@/types';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const useNewsList = (params: NewsListParams = {}) =>
  useQuery({
    queryKey: ['news', params],
    queryFn: () => newsApi.getAll(params),
  });

export const useNews = (id: number) =>
  useQuery({
    queryKey: ['news', id],
    queryFn: () => newsApi.getById(id),
    enabled: !!id,
  });

export const useCreateNews = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();
  return useMutation({
    mutationFn: (data: Partial<Artikel>) => newsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news'] });
      feedback.success('Berita berhasil dibuat');
    },
    onError: (error) => {
      feedback.error('Gagal membuat berita', error);
    },
  });
};

export const useUpdateNews = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Artikel> }) => newsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news'] });
      feedback.success('Berita berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui berita', error);
    },
  });
};

export const useDeleteNews = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();
  return useMutation({
    mutationFn: (id: number) => newsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news'] });
      feedback.success('Berita berhasil dihapus');
    },
    onError: (error) => {
      feedback.error('Gagal menghapus berita', error);
    },
  });
};
